import Button from './button';
import Group from './group';

export const Radio = {
  Button,
  Group,
}

export default Radio;